import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var SplitFactor = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(SplitFactor, _ValueWithRandom);
  var _super = _createSuper(SplitFactor);
  function SplitFactor() {
    var _this;
    _classCallCheck(this, SplitFactor);
    _this = _super.call(this);
    _this.value = 3;
    return _this;
  }
  return _createClass(SplitFactor);
}(ValueWithRandom);